import { useState } from 'react'
import { useAuth } from '../context/AuthContext'
import { supabase } from '../supabaseClient'

export default function Login() {
  const { signIn } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [showReset, setShowReset] = useState(false)
  const [resetEmail, setResetEmail] = useState('')
  const [resetSent, setResetSent] = useState(false)
  const [resetLoading, setResetLoading] = useState(false)
  const [resetError, setResetError] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError('')
    const { error } = await signIn(email, password)
    if (error) setError(error.message)
    setLoading(false)
  }

  const handleReset = async (e) => {
    e.preventDefault()
    setResetError('')
    setResetLoading(true)
    const { error } = await supabase.auth.resetPasswordForEmail(resetEmail, {
      redirectTo: `${window.location.origin}/reset-password`,
    })
    if (error) setResetError(error.message)
    else setResetSent(true)
    setResetLoading(false)
  }

  return (
    <main className="min-h-screen bg-off-white flex items-center justify-center p-4">
      <div className="bg-navy rounded-xl p-10 w-full max-w-md flex flex-col items-center">
        <img src="/4lc-logo.png" alt="4 Level Compass" className="w-96 mb-6" />
        <h1 className="font-inter text-brand-grey text-sm tracking-widest uppercase mb-8">
          4 Level Compass
        </h1>

        {!showReset ? (
          <form onSubmit={handleSubmit} className="w-full space-y-4">
            <div>
              <label htmlFor="login-email" className="block text-brand-grey text-sm mb-1">Email</label>
              <input
                id="login-email"
                name="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-navy border border-brand-grey rounded-lg px-4 py-3 text-white placeholder-brand-grey focus:outline-none focus:border-gold text-base"
                placeholder="your@email.com"
                required
              />
            </div>
            <div>
              <label htmlFor="login-password" className="block text-brand-grey text-sm mb-1">Password</label>
              <input
                id="login-password"
                name="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-navy border border-brand-grey rounded-lg px-4 py-3 text-white placeholder-brand-grey focus:outline-none focus:border-gold text-base"
                placeholder="••••••••"
                required
              />
            </div>
            {error && <p className="text-brand-red text-sm font-inter">{error}</p>}
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-gold text-navy font-oswald font-semibold py-4 rounded-lg tracking-wider uppercase hover:opacity-90 transition disabled:opacity-50 text-lg"
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
            <button
              type="button"
              onClick={() => { setShowReset(true); setError(''); setResetError('') }}
              className="w-full text-brand-grey font-inter text-sm hover:text-white transition"
            >
              Forgot your password?
            </button>
          </form>
        ) : (
          <div className="w-full">
            {!resetSent ? (
              <form onSubmit={handleReset} className="space-y-4">
                <p className="font-inter text-brand-grey text-sm text-center mb-4">
                  Enter your email and we will send you a reset link.
                </p>
                <label htmlFor="reset-email" className="sr-only">Email address for password reset</label>
                <input
                  id="reset-email"
                  type="email"
                  name="reset-email"
                  value={resetEmail}
                  onChange={(e) => setResetEmail(e.target.value)}
                  className="w-full bg-navy border border-brand-grey rounded-lg px-4 py-3 text-white placeholder-brand-grey focus:outline-none focus:border-gold text-base"
                  placeholder="your@email.com"
                  required
                />
                {resetError && <p className="text-brand-red text-sm font-inter">{resetError}</p>}
                <button
                  type="submit"
                  disabled={resetLoading}
                  className="w-full bg-gold text-navy font-oswald font-semibold py-4 rounded-lg tracking-wider uppercase hover:opacity-90 transition disabled:opacity-50"
                >
                  {resetLoading ? 'Sending...' : 'Send Reset Link'}
                </button>
                <button
                  type="button"
                  onClick={() => { setShowReset(false); setError(''); setResetError('') }}
                  className="w-full text-brand-grey font-inter text-sm hover:text-white transition"
                >
                  Back to Sign In
                </button>
              </form>
            ) : (
              <div className="text-center space-y-4">
                <p className="font-oswald text-2xl text-gold">Check Your Email</p>
                <p className="font-inter text-brand-grey text-sm">
                  We sent a password reset link to {resetEmail}.
                </p>
                <button
                  onClick={() => { setShowReset(false); setResetSent(false); setError(''); setResetError('') }}
                  className="w-full bg-gold text-navy font-oswald font-semibold py-4 rounded-lg tracking-wider uppercase hover:opacity-90 transition"
                >
                  Back to Sign In
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </main>
  )
}